import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Reizen heruitvinden",
      subtitle:
        "Een ethische, lokale en menselijke visie op het toerisme van morgen.",
    },
    mission: {
      badge: "Onze Missie",
      title: "Eerlijk toerisme",
      description:
        "Wij geloven dat reizen toegankelijk moet zijn voor iedereen, zonder dure tussenpersonen. DONKEY TRAVEL stelt eigenaars in staat om vrij te reizen dankzij de waarde van hun eigen woning.",
    },
    philosophy: {
      badge: "Onze Filosofie",
      title: "Gemaakt in Frankrijk & Menselijk",
      description:
        "Geworteld in de Somme-vallei verdedigen we een ambachtelijk model tegen techgiganten. Geen ondoorzichtige algoritmen, alleen gezond verstand en gezelligheid.",
      values: {
        fair: {
          title: "Eerlijk",
          desc: "0% commissie op uitwisselingen. Alleen een transparant abonnement.",
        },
        local: {
          title: "Lokale Verankering",
          desc: "Trots op onze Franse wortels, promoten we respectvol toerisme.",
        },
        community: {
          title: "Gemeenschap",
          desc: "Een privéclub van vertrouwde eigenaars die dezelfde waarden delen.",
        },
      },
    },
    team: {
      badge: "Het team",
      title: "Gepassioneerden in uw dienst",
      subtitle: "Achter het platform, mensen die houden van reizen en delen.",
      members: {
        ceo: {
          name: "Plük",
          role: "Oprichter van DONKEY TRAVEL • Ontwikkelaar • Airbnb Superhost voor 4 jaar",
          bio: "Jarenlang heb ik reizigers ontvangen in mijn huisjes, waar ik zelf ook naartoe had kunnen gaan als DONKEY TRAVEL had bestaan. Daarom heb ik DONKEY TRAVEL gecreëerd: om hosts in staat te stellen elkaar te ontvangen en op een andere manier te reizen.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Platform-architect, bewaker van de beveiliging.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Hoofd Communicatie",
          bio: "De stem van DONKEY TRAVEL naar onze gemeenschap.",
        },
      },
    },
    investors: {
      badge: "Investeerders",
      title: "Doe mee aan het avontuur",
      description:
        "DONKEY TRAVEL groeit. We zoeken partners die onze visie op duurzaam en eerlijk toerisme delen.",
      cta: "Neem contact op om te investeren",
    },
  },
  trokOrigin: {
    badge: "Het concept begrijpen",
    title: "Wat is Uitwisseling precies?",
    subtitle:
      "Een directe ruil tussen twee personen, zonder tussenpersoon of ingewikkeld puntensysteem",
    etymology: {
      title: "De oorsprong van het woord",
      historicalTitle: "Een eeuwenoude praktijk",
      text1:
        'Het woord "Troc" verschijnt in het Frans in de 14e eeuw, afgeleid van het werkwoord "troquer". Het vindt zijn wortels in het Spaanse "trucque" en het Waalse "trouk", wat het idee van directe ruil oproept.',
      text2:
        'Getuigd vanaf 1364 in de vorm "truke" in Anglo-Normandische documenten, en vervolgens officieel gemaakt in 1464 in de patentbrieven van Lodewijk XI: "voor de verkoop, ruil of uitwisseling van deze waren".',
      text3:
        "Bij DONKEY TRAVEL hebben we deze eeuwenoude filosofie behouden: u ruilt uw woning direct met een andere eigenaar. Geen virtueel geld, geen punten om te verzamelen. Gewoon een afspraak tussen twee mensen.",
      from: "Etymologie",
      meaning: "Direct ruilen, van mens tot mens",
      century14: "14e eeuw",
      firstAttestation: "Eerste vermelding in het Frans",
      century15: "15e eeuw",
      officialUse: "Officieel gebruik door Lodewijk XI",
      today: "Vandaag",
      modernPractice: "Moderne en collaboratieve praktijk",
    },
    direct: {
      title: "Alleen directe ruil",
      description:
        "In tegenstelling tot punten- of kredietsystemen, werkt DONKEY TRAVEL volgens het principe van pure ruilhandel. U onderhandelt direct met een andere eigenaar: uw nachten tegen de zijne. Dit is de essentie van ruilhandel zoals die al sinds de 14e eeuw bestaat.",
      result: "Directe ruil gevalideerd!",
    },
    noTriangulation: {
      title: "Geen triangulatie",
      description:
        "Geen complex systeem waarbij A aan B geeft die aan C geeft. Hier is het simpel: u vindt iemand, u onderhandelt samen (gelijktijdige of verschoven data), u ruilt. Punt.",
      noPoints: "Geen punten tellen",
    },
    meetHost: {
      title: "Ontmoet een andere Airbnb-gastheer",
      description:
        "DONKEY TRAVEL is niet alleen een woning ontdekken of reizen. Het is vooral een andere gastvrijheidsliefhebber ontmoeten, iemand die uw waarden van gastvrijheid deelt. Ruilhandel is altijd een sociale praktijk geweest voordat het economisch was.",
      share: "Deel uw ervaringen als gastheer",
      tips: "Wissel uw beste tips uit",
      friendship: "Creëer duurzame vriendschappen",
      badge: "Gastheergemeenschap",
      badgeSub: "Authentieke ontmoetingen",
      step2Title: "2. Vriendschappelijk contract op DONKEY TRAVEL",
      step2Desc:
        "Ze ondertekenen het ruilcontract direct op het platform en ontvangen de PDF per e-mail. Alles is veilig en officieel.",
      contractSigned: "Contract ondertekend en beveiligd",
      step3Title: "3. Marie komt aan in Parijs (2 weken later)",
      step3Desc:
        "Jean verwelkomt Marie hartelijk. Hij is onder de indruk: het appartement is onberispelijk, Marie respecteert alles. Wat een verschil met sommige Airbnb-reizigers! Ze bespreken hun ervaringen als gastheren tijdens een kop koffie.",
      step4Title: "4. Jean ontdekt Reims (6 maanden later)",
      step4Desc:
        "Jean komt aan in het gîte van Marie in Reims. De omgeving is prachtig! Marie nodigt hem uit voor het diner, ze eten samen en verbeteren de wereld door te praten over reizen, Airbnb en hun beste anekdotes als gastheren.",
      step5Title: "5. Een duurzame vriendschap",
      step5Desc:
        "Marie en Jean blijven contact houden. Ze besluiten regelmatig hun woningen te ruilen. Meer dan een simpele ruil, is er een echte vriendschap ontstaan dankzij TRAVELTROK.",
      spiritTitle: "Dat is de geest van DONKEY TRAVEL!",
      spiritDesc:
        "Authentieke uitwisselingen tussen gepassioneerde eigenaars, met respect en gezelligheid. Geen punten, geen triangulatie, gewoon echte ouderwetse ruilhandel.",
    },
    negotiation: {
      badge: "Speelse onderhandeling",
      title: "Onderhandel als een spel!",
      description:
        "10 nachten tegen 5? Waarom niet! Doe een bod, ontvang een tegenbod, vind een akkoord. Alles in een goede sfeer. Zoals in de tijd van de eerste ruilhandel, maakt onderhandelen deel uit van het plezier.",
      marieProperty: "Gîte in Reims",
      jeanProperty: "Appartement in Parijs",
      marieLocation: "In haar gîte in Reims",
      jeanLocation: "In zijn appartement in Parijs",
      marieAccepts: "Marie accepteert het bod",
      offers: "Bod",
      proposes: "Stelt voor",
      nights: "nachten",
      status: {
        initial: "Marie doet een bod...",
        counter: "Jean doet een tegenbod!",
        negotiate: "Marie onderhandelt...",
        deal: "Deal gesloten! 🎉",
      },
      chat: {
        msg1: "Ik stel je {{marieNights}} nachten voor in mijn gîte in Reims tegen {{jeanNights}} nachten in Parijs!",
        msg2: "Jean vindt de woning van Marie erg goed...",
        msg3: "Je gîte is prachtig! Ik ben aardig, ik stel je {{jeanNights}} nachten in Parijs voor 😊",
        msg4: "Deal gesloten! 🤝",
        msg5: "Marie bekijkt de beschikbaarheid van Jean...",
      },
      nextStep: "Volgende stap",
      restart: "Opnieuw beginnen",
      points: {
        flexible: "Flexibele onderhandeling",
        friendly: "Gezellige sfeer",
        fair: "Eerlijk akkoord",
      },
    },
    flexibility: {
      title: "Totale flexibiliteit",
      description:
        "In tegenstelling tot traditionele uitwisselingen hoeft u niemand te vinden die uw woning wil precies wanneer u de zijne wilt. Verzamel Nachten en gebruik ze wanneer u maar wilt!",
    },
    example: {
      person1: "Marie",
      location1: "Parijs, Frankrijk",
      person2: "Jean",
      location2: "Lyon, Frankrijk",
      result: "Ruil geslaagd!",
    },
  },
  exchange: {
    title: "Hoe werkt het?",
    subtitle:
      "Een eenvoudig en veilig systeem om uw woning in alle vertrouwen te ruilen",
    features: {
      secure: {
        title: "Veilige uitwisselingen",
        description:
          "Alle leden zijn geverifieerd en beoordelingen garanderen de transparantie van elke ruil.",
      },
      sync: {
        title: "Kalendersynchronisatie",
        description:
          "Synchroniseer automatisch uw beschikbaarheid met uw bestaande Airbnb-kalender.",
      },
      global: {
        title: "Europees netwerk",
        description:
          "Toegang tot hosts in de beschikbare Europese landen op TRAVELTROK.",
      },
      chat: {
        title: "Geïntegreerde berichten",
        description:
          "Communiceer direct met andere eigenaars om uw uitwisselingen te organiseren.",
      },
      rating: {
        title: "Beoordelingssysteem",
        description:
          "Raadpleeg beoordelingen en scores om uw ruilpartners in alle vertrouwen te kiezen.",
      },
      savings: {
        title: "Gegarandeerde besparingen",
        description:
          "Reis gratis door uw Nachten te gebruiken in plaats van te betalen voor dure accommodaties.",
      },
    },
    steps: {
      title: "In 3 eenvoudige stappen",
      step1: {
        title: "Maak uw profiel aan",
        description:
          "Registreer u en voeg in enkele minuten informatie over uw Airbnb-woning toe.",
      },
      step2: {
        title: "Vind uw bestemming",
        description:
          "Blader door beschikbare woningen en vind uw droombestemming.",
      },
      step3: {
        title: "Ruil en reis",
        description:
          "Stel een ruil voor, bevestig de data en geniet gratis van uw verblijf!",
      },
    },
  },
  worldMap: {
    title: "Top 20 meest actieve landen",
    subtitle: "Ontdek de landen waar woningruil vandaag het populairst is",
    description:
      "Onze gemeenschap groeit elke dag met nieuwe eigenaars over de hele wereld. Ontdek waar u gratis naartoe kunt reizen.",
    badge: "Real-time ranglijst",
    properties: "woningen",
    cta: "Bekijk alle bestemmingen",
    exchangesToday: "Ruilen vandaag",
    activeCountries: "Actieve landen",
    vsYesterday: "vs. gisteren",
    fullRanking: "Volledige ranglijst",
    countries: {
      Guadeloupe: "Guadeloupe",
      Martinique: "Martinique",
      Guyane: "Frans-Guyana",
      "La Réunion": "Réunion",
      Mayotte: "Mayotte",
      "Polynésie française": "Frans-Polynesië",
      "Nouvelle-Calédonie": "Nieuw-Caledonië",
      "Îles Canaries": "Canarische Eilanden",
      "Ceuta & Melilla": "Ceuta & Melilla",
      Madère: "Madeira",
      Açores: "Azoren",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "Sint Maarten",
      Bermudes: "Bermuda",
      "Îles Caïmans": "Kaaimaneilanden",
      Gibraltar: "Gibraltar",
      france: "Frankrijk",
      spain: "Spanje",
      italy: "Italië",
      usa: "Verenigde Staten",
      uk: "Verenigd Koninkrijk",
      germany: "Duitsland",
      portugal: "Portugal",
      netherlands: "Nederland",
      canada: "Canada",
      australia: "Australië",
      belgium: "België",
      switzerland: "Zwitserland",
      greece: "Griekenland",
      mexico: "Mexico",
      brazil: "Brazilië",
      austria: "Oostenrijk",
      croatia: "Kroatië",
      thailand: "Thailand",
      morocco: "Marokko",
    },
  },
  calendar: {
    title: "Automatische synchronisatie met Airbnb",
    subtitle: "Verbind uw Airbnb-kalender met één klik",
    description:
      "Uw beschikbaarheid wordt automatisch gesynchroniseerd. Geen noodzaak meer om twee kalenders apart te beheren.",
    features: {
      sync: {
        title: "Tweerichtingssynchronisatie",
        description:
          "Uw Airbnb- en TRAVELTROK-kalenders blijven altijd automatisch up-to-date",
      },
      realtime: {
        title: "Real-time updates",
        description:
          "Elke wijziging wordt direct gesynchroniseerd op beide platforms",
      },
      smart: {
        title: "Slim beheer",
        description:
          "Vermijd dubbele boekingen dankzij ons geavanceerde synchronisatiesysteem",
      },
    },
    cta: "Verbind mijn kalender",
  },
  airbnb: {
    title: "Al Airbnb-eigenaar?",
    subtitle: "Sluit u aan bij DONKEY TRAVEL en begin gratis te reizen",
    description:
      "Importeer automatisch uw Airbnb-woninginformatie en begin vandaag nog met ruilen.",
    features: {
      verification: {
        title: "Automatische verificatie van uw profiel",
      },
      import: {
        title: "Import van uw foto's en beschrijvingen",
      },
      trust: {
        title: "Word lid van een vertrouwde gemeenschap",
      },
    },
    cta: "Verbind mijn Airbnb",
  },
  membersMap: {
    title: "Ledenkaart",
    searchPlaceholder: "Zoek een bestemming, stad...",
    filters: "Filters",
    radius: "Straal",
    radiusAuto: "Automatisch",
    reset: "Resetten",
    filterPets: "Huisdieren toegestaan",
    filterVerified: "Geverifieerde hosts",
    filterRating: "4.8+",
    filterAllTypes: "Alle types",
    oneTraveler: "1 reiziger",
    multipleTravelers: "{{count}} reizigers",
    dates: "Data",
    addDates: "Data toevoegen",
    startDate: "Vertrek",
    endDate: "Terugkomst",
    listingsTitle: "Woningen",
    listingsSubtitle: "Selecteer om op de kaart te zien.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Filters wissen",
    guestsShort: "p.",
    bedroomsShort: "slp.",
    surfaceAreaUnit: "m²",
    perNight: "/ nacht",
    online: "Verbonden",
    offline: "Niet verbonden",
    verified: "Geverifieerd",
    favorite: "Favoriet",
    favorites: "Favorieten",
    members: "Leden",
    exchanges: "uitwisselingen",
    rooms: "kamers",
    mapTitle: "Interactieve kaart van TRAVELTROK-leden",
    countries: "Landen",
    results: "resultaten",
    viewProfile: "Bekijk profiel",
    proposeExchange: "Ruil voorstellen",
    showFavoritesOnly: "Alleen favorieten tonen",
    advancedSearch: "Geavanceerd zoeken",
    refineSearch: "Verfijn uw zoekopdracht",
    activeFilter: "actief filter",
    activeFilters: "actieve filters",
    availabilityDates: "Beschikbaarheidsdata",
    quickPeriods: "Snelle periodes",
    thisMonth: "Deze maand",
    nextMonth: "Volgende maand",
    next3Months: "3 komende maanden",
    summer: "Zomer",
    autumn: "Herfst",
    winter: "Winter",
    arrival: "Aankomst",
    departure: "Vertrek",
    flexibleDates: "Flexibele data",
    clear: "Wissen",
    propertyTypeTitle: "Type woning",
    apartment: "Appartement",
    house: "Huis",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capaciteit & kamers",
    numberOfTravelers: "Aantal reizigers",
    all: "Alle",
    numberOfRooms: "Aantal kamers",
    minimumSurface: "Minimum oppervlakte",
    equipments: "Voorzieningen",
    wifi: "Wifi",
    pool: "Zwembad",
    parking: "Parkeerplaats",
    airConditioning: "Airconditioning",
    garden: "Tuin",
    terrace: "Terras",
    fireplace: "Open haard",
    barbecue: "Barbecue",
    bike: "Fiets",
    sauna: "Sauna",
    gym: "Sportschool",
    washingMachine: "Wasmachine",
    statusAvailability: "Status & beschikbaarheid",
    onlineAvailability: "Realtime beschikbaarheid",
    onlineOnly: "Alleen verbonden",
    verifiedMembersOnly: "Alleen geverifieerde leden",
    ratingExperience: "Beoordeling & ervaring",
    minimumRating: "Minimum beoordeling",
    minimumExchanges: "Minimum aantal ruilen",
    matchingMembers: "overeenkomende leden",
    matchingMember: "overeenkomend lid",
    seeResults: "Bekijk de",
    result: "resultaat",
    resetAllFilters: "Alle filters resetten",
    rating: "Beoordeling",
    travelers: "Reizigers",
    contact: "Contact opnemen",
    searchMemberCity: "Zoek een lid, stad, land...",
    noFavorite: "Geen favoriet",
    addFavoritesHint:
      "Voeg leden toe aan uw favorieten door op het hartje te klikken",
    noMemberFound: "Geen lid gevonden",
    tryModifyFilters: "Probeer uw filters te wijzigen",
    viewAllMembers: "Bekijk alle leden",
    modifyFilters: "Filters wijzigen",
    favoritesOnly: "Alleen favorieten",
    addToFavorites: "Toevoegen aan favorieten",
    removeFromFavorites: "Verwijderen uit favorieten",
    loading: "Laden...",
    sortBy: "Sorteren op",
    relevance: "Relevantie",
    newest: "Nieuwste",
    noResults: "Geen resultaten gevonden",
    tryDifferentFilters: "Probeer uw zoekfilters aan te passen",
    membersList: "Ledenlijst",
    membersFound: "leden gevonden",
    visibleMembers: "Zichtbare leden",
    legend: "Legenda",
    availableProperty: "Woning beschikbaar",
    selected: "Geselecteerd",
    visibleByAll: "Zichtbaar voor iedereen",
    allMembersSeeYou: "Alle leden zien u",
    targetedMode: "Gerichte modus",
    countriesSelected: "landen geselecteerd",
    countrySelected: "land geselecteerd",
    myVisibility: "Mijn zichtbaarheid",
    whoCanSee: "Wie kan mijn woning op de kaart zien?",
    visibleByAllTitle: "Zichtbaar voor iedereen",
    visibleByAllDesc:
      "Alle leden van de gemeenschap kunnen uw woning zien en u een ruil voorstellen.",
    visibleByAllHint: "Maximale zichtbaarheid en kansen",
    active: "ACTIEF",
    targetedModeTitle: "Gerichte modus",
    targetedModeDesc:
      "Alleen leden uit de landen die u zoekt kunnen uw woning zien. Maximale discretie.",
    targetedModeHint: "U ziet en wordt alleen gezien door uw bestemmingen",
    myDesiredDestinations: "Mijn gewenste bestemmingen",
    clearAll: "Alles wissen",
    searchCountry: "Zoek een land...",
    member: "lid",
    membersCount: "leden",
    noCountryFound: "Geen land gevonden",
    targetedInfoTitle: "Uw woning verschijnt alleen voor leden in",
    targetedInfoDesc: "Anderen zullen u niet op de kaart zien.",
    targetedExample:
      "Voorbeeld: als u alleen naar Nederland wilt, zien alleen Nederlandse leden uw profiel.",
    selectAtLeastOneCountry:
      "Selecteer ten minste één land om de gerichte modus te activeren.",
    propertyTypes: {
      appartement: "Appartement",
      maison: "Huis",
      villa: "Villa",
      loft: "Loft",
      luxe: "Luxe",
      insolite: "Bijzonder",
    },
    pricePerNight: "PRIJS PER NACHT (€)",
    min: "Min",
    max: "Max",
    sortResults: "RESULTATEN SORTEREN",
    sort: {
      recommended: "✨ Aanbevolen",
      priceAsc: "💶 Prijs oplopend",
      priceDesc: "💎 Prijs aflopend",
    },
    amenitiesTitle: "VOORZIENINGEN",
    amenitiesTabs: {
      all: "ALLE",
      essentials: "ESSENTIEEL",
      features: "COMFORT",
      location: "LOCATIE",
      safety: "VEILIGHEID",
    },
  },
  amenities: {
    wifi: "Wifi",
    tv: "Televisie",
    kitchen: "Keuken",
    washing_machine: "Wasmachine",
    ac: "Airconditioning",
    heating: "Verwarming",
    workspace: "Werkplek",
    iron: "Strijkijzer",
    hair_dryer: "Föhn",
    pool: "Zwembad",
    hottub: "Jacuzzi",
    patio: "Terras",
    bbq: "Barbecue",
    parking: "Gratis parkeren",
    gym: "Sportschool",
    fireplace: "Open haard",
    breakfast: "Ontbijt",
    beachfront: "Aan zee",
    ski_in_out: "Aan de piste",
    lake_access: "Toegang tot meer",
    smoke_detector: "Rookmelder",
    first_aid: "EHBO-doos",
    fire_extinguisher: "Brandblusser",
  },
  destinations: {
    title: "Bestemmingen",
    searchPlaceholder: "Zoek een bestemming...",
    destinationsFound: "bestemmingen gevonden",
    noResults: "Geen resultaat",
    tryDifferentSearch: "Probeer een andere zoekopdracht",
    sortMembers: "Meeste leden",
    sortProperties: "Meeste woningen",
    sortName: "Naam (A-Z)",
    all: "Alle",
    members: "leden",
    properties: "woningen",
    explore: "Verken deze bestemming",
    stats: {
      destinations: "Bestemmingen",
      members: "Leden",
      properties: "Woningen",
      countries: "Landen",
    },
    countriesIn: "Landen in",
    selectCountry: "— selecteer een land om te filteren",
    continents: {
      Europe: "Europa",
      "Amérique du Nord": "Noord-Amerika",
      "Amérique du Sud": "Zuid-Amerika",
      Asie: "Azië",
      Afrique: "Afrika",
      Océanie: "Oceanië",
    },
    countries: {
      Turquie: "Turkije",
      France: "Frankrijk",
      "Pays-Bas": "Nederland",
      "Royaume-Uni": "Verenigd Koninkrijk",
      Espagne: "Spanje",
      Italie: "Italië",
      Tchéquie: "Tsjechië",
      Grèce: "Griekenland",
      Portugal: "Portugal",
      Autriche: "Oostenrijk",
      Écosse: "Schotland",
      Hongrie: "Hongarije",
      Croatie: "Kroatië",
      Danemark: "Denemarken",
      Suède: "Zweden",
      Suisse: "Zwitserland",
      Belgique: "België",
      Norvège: "Noorwegen",
      Irlande: "Ierland",
      Pologne: "Polen",
      Finlande: "Finland",
      Islande: "IJsland",
      Roumanie: "Roemenië",
      Monténégro: "Montenegro",
      "États-Unis": "Verenigde Staten",
      Canada: "Canada",
      Mexique: "Mexico",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "Dominicaanse Republiek",
      Guatemala: "Guatemala",
      Brésil: "Brazilië",
      Argentine: "Argentinië",
      Pérou: "Peru",
      Colombie: "Colombia",
      Chili: "Chili",
      Équateur: "Ecuador",
      Uruguay: "Uruguay",
      Bolivie: "Bolivia",
      Chine: "China",
      Thaïlande: "Thailand",
      Indonésie: "Indonesië",
      Vietnam: "Vietnam",
      "Corée du Sud": "Zuid-Korea",
      Inde: "India",
      Cambodge: "Cambodja",
      Jordanie: "Jordanië",
      Maldives: "Maldiven",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Filippijnen",
      Ouzbékistan: "Oezbekistan",
      Égypte: "Egypte",
      Maroc: "Marokko",
      "Afrique du Sud": "Zuid-Afrika",
      Tanzanie: "Tanzania",
      Kenya: "Kenia",
      Sénégal: "Senegal",
      Madagascar: "Madagaskar",
      Tunisie: "Tunesië",
      Zimbabwe: "Zimbabwe",
      Namibie: "Namibië",
      "Île Maurice": "Mauritius",
      Rwanda: "Rwanda",
      Australie: "Australië",
      "Nouvelle-Zélande": "Nieuw-Zeeland",
      "Polynésie française": "Frans-Polynesië",
      Fidji: "Fiji",
      "Nouvelle-Calédonie": "Nieuw-Caledonië",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Parijs",
      "Mont Saint-Michel": "Mont Saint-Michel",
      Marseille: "Marseille",
      Amsterdam: "Amsterdam",
      Londres: "Londen",
      Barcelone: "Barcelona",
      Madrid: "Madrid",
      Venise: "Venetië",
      Rome: "Rome",
      "Côte Amalfitaine": "Amalfikust",
      Prague: "Praag",
      Santorin: "Santorini",
      Athènes: "Athene",
      Lisbonne: "Lissabon",
      Porto: "Porto",
      Vienne: "Wenen",
      Édimbourg: "Edinburgh",
      Budapest: "Boedapest",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Kopenhagen",
      Stockholm: "Stockholm",
      Zermatt: "Zermatt",
      Bruges: "Brugge",
      Bergen: "Bergen",
      Dublin: "Dublin",
      Cracovie: "Krakau",
      Helsinki: "Helsinki",
      Reykjavik: "Reykjavik",
      Bucarest: "Boekarest",
      Kotor: "Kotor",
      "New York": "New York",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Hawaï",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Quebec",
      Cancún: "Cancún",
      "Mexico City": "Mexico-Stad",
      "San José": "San José",
      "La Havane": "Havana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogotá",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokio",
      Kyoto: "Kyoto",
      Pékin: "Peking",
      Shanghai: "Shanghai",
      "Hong Kong": "Hongkong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Ho Chi Minhstad",
      Séoul: "Seoul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Kathmandu",
      Manille: "Manilla",
      Samarcande: "Samarkand",
      Petra: "Petra",
      "Le Caire": "Caïro",
      Marrakech: "Marrakech",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Kaapstad",
      Johannesburg: "Johannesburg",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Masai Mara Safari",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarivo",
      Tunis: "Tunis",
      "Chutes Victoria": "Victoriawatervallen",
      Windhoek: "Windhoek",
      "Île Maurice": "Mauritius",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Great Barrier Reef",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fiji",
      Nouméa: "Nouméa",
      Apia: "Apia",
      "Baie d'Halong": "Ha Longbaai",
      Maldives: "Maldiven",
    },
  },
  story: {
    badge: "Een waargebeurd verhaal",
    title: "Chloé & Hugo: de perfecte ruil",
    subtitle:
      "Wanneer een Parijse die moe is van de stad een plattelandsbewoner ontmoet die droomt van Parijs...",
    chloé: {
      aptAlt: "Appartement van Chloé in Parijs",
      quotaExceeded: "Airbnb-quotum overschreden!",
      role: "Airbnb-host in Parijs",
      speech1:
        'Ik heb <strong class="text-red-600">mijn quotum van 120 nachten overschreden</strong>... Verhuren onmogelijk. En eerlijk gezegd ben ik het Parijse lawaai zat. 😩',
      nightsTag: "120/120 nachten",
      tiredTag: "Moe van Parijs",
      dreamsOf: "Chloé droomt van...",
      dreamTitle: "De rust van het platteland",
      dreamDesc: "Groen, stilte, een sauna... het paradijs!",
      searching: "Zoekt een gîte op het platteland",
      findsLuc: "Vindt Hugo!",
      speech2:
        "Eindelijk rust! De sauna na een boswandeling, dat is <strong>puur geluk</strong>. 🌿✨",
      review:
        "De gîte van Hugo is een paradijsje! De sauna na een boswandeling is puur geluk. We zijn vrienden geworden! Ik beveel het 200% aan.",
    },
    hugo: {
      giteAlt: "Gîte van Hugo op het platteland",
      available: "Het hele jaar beschikbaar",
      location: "Platteland, Frankrijk",
      role: "Airbnb-host op het platteland",
      speech1:
        'Mijn gîte heeft een <strong class="text-sage-600">tuin, een sauna en een massagestoel</strong>... maar ik ben het platteland zat. Ik droom van Parijs! 🗼',
      dreamsOf: "Hugo droomt van...",
      dreamTitle: "De lichten van Parijs",
      dreamDesc: "De musea, de cafés, de Eiffeltoren... eindelijk!",
      searching: "Zoekt een appartement in Parijs",
      findsMaya: "Vindt Chloé!",
      speech2:
        "Parijs, eindelijk! Het Louvre, de bistro's, de daken... het is <strong>magisch</strong>! 🗼🥐",
      review:
        "Het appartement van Chloé is ongelooflijk, uitzicht over de daken van Parijs! En dat allemaal zonder haar quotum aan te raken. Ruilen is geweldig!",
    },
    tags: {
      garden: "Tuin",
      sauna: "Sauna",
      massage: "Massage",
      countryside: "Platteland",
      bigGarden: "Grote tuin",
      restaurants: "Restaurants",
      museums: "Musea",
    },
    match: {
      spark: "De klik!",
      title: "Ze ontdekken DONKEY TRAVEL",
      perfect: "Perfecte match!",
    },
    quota: {
      title: "Buiten Airbnb-quotum = 100% gratis!",
      description:
        "Het verblijf van Hugo raakt het quotum van Chloé niet. Het is een ruil, geen verhuur. Iedereen wint!",
      totalCost: "Totale kosten",
      quotaNight: "Quotum nacht",
    },
    happyEnd: {
      title: "Iedereen is blij! 🎊",
      subtitle:
        "Chloé en Hugo zijn vrienden geworden. Ze delen hun tips als hosts en plannen al een volgende ruil!",
      exchangeSuccess: "Geslaagde ruil",
      newFriendship: "Nieuwe vriendschap",
      outsideQuota: "Buiten quotum",
      free: "100% gratis",
    },
  },
  messaging: {
    messages: "Berichten",
    searchPlaceholder: "Zoek een gesprek...",
    all: "Alle",
    unread: "Ongelezen",
    archived: "Gearchiveerd",
    online: "Verbonden",
    offline: "Niet verbonden",
    messagePlaceholder: "Schrijf een bericht...",
    writeMessage: "Schrijf een bericht",
    sending: "Verzenden...",
    characters: "tekens",
    noConversation: "Geen gesprek",
    notificationMessage: "Nieuw bericht",
    quickActions: "Snelle acties",
    proposeExchange: "Ruil voorstellen",
    proposeExchangeTitle: "Ruilvoorstel",
    checkAvailability: "Beschikbaarheid controleren",
    report: "Rapporteren",
    hisProperty: "Zijn/haar woning",
    rooms: "slaapkamers",
    guests: "reizigers",
    verifiedOwner: "Geverifieerde eigenaar",
    viewAirbnbListing: "Bekijk Airbnb-advertentie",
    details: "Gegevens",
    desiredDates: "Gewenste data",
    arrival: "Aankomst",
    departure: "Vertrek",
    period: "Periode",
    duration: "Duur",
    nights: "nachten",
    numberOfTravelers: "Aantal reizigers",
    traveler: "reiziger",
    travelers: "reizigers",
    person: "persoon",
    persons: "personen",
    dateFlexibility: "Datumflexibiliteit",
    exactDates: "Exacte data",
    flex1to2: "± 1-2 dagen",
    flex3to5: "± 3-5 dagen",
    flexWeek: "± 1 week",
    personalMessage: "Persoonlijk bericht",
    summary: "Samenvatting",
    termsAccept: "Ik ga akkoord met de ruilvoorwaarden van DONKEY TRAVEL",
    sendProposal: "Voorstel versturen",
    proposalSent: "Voorstel verzonden!",
    proposalSentMessage: "Uw voorstel is succesvol verzonden",
    close: "Sluiten",
    today: "Vandaag",
    selectConversation: "Selecteer een gesprek",
    selectConversationHint: "Kies een eigenaar om te chatten",
  },
  destination_introuvable: `Bestemming niet gevonden`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Deze bestemming bestaat niet of is verplaatst.`,
  retour_aux_destinations: `Terug naar bestemmingen`,
  pr_t___d_couvrir_: `Klaar om te ontdekken`,
  r_server_ce_s_jour: `Boek dit verblijf`,
  explorer_d_apos_autres_destinations: `Ontdek andere bestemmingen`,
  acc_s_r_serv_: `Gereserveerde toegang`,
  europe_unique: `Eén Europa`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/jaar om te ruilen in heel Europa.`,
  lancement_2026: `Lancering 2026`,
  club_d__change_h_tes_airbnb: `Airbnb Host Exchange Club`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Optimaliseer uw daluren dankzij uitwisselingen`,
  rejoindre_le_club: `Word lid van de club`,
  trouver_un_h_te: `Zoek een host`,
  r_serv__aux_h_tes_traveltrok: `Gereserveerd voor TRAVELTROK-gasten`,
  voyagez_gratuitement_gr_ce___votre_logement: `Reis gratis met uw accommodatie`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Verwelkom leden en word terug welkom geheten. Een eenvoudige, directe en geldloze uitwisseling tussen eigenaren.`,
  devenir_h_te: `Word gastheer`,
  comment__a_marche__: `Hoe werkt het?`,
  amis_partageant_un_repas_en_corse: `Vrienden delen een maaltijd op Corsica`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"We hebben ons huis in Lyon ingeruild voor een villa op Corsica. Kosten: € 0."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, lid sinds 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Geen munten, geen punten. Gewoon een overeenkomst tussen twee eigenaren. Ik kom naar jouw huis, jij komt naar mijn huis.`,
  "1__accord_mutuel": `1. Onderlinge overeenstemming`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Je vindt een lid dat je leuk vindt en je gaat ermee akkoord om van accommodatie te wisselen.`,
  "2__flexibilit__totale": `2. Totale flexibiliteit`,
  "3__z_ro_comptabilit_": `3. Nulboekhouding`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Geen punten om te tellen. Gewoon het plezier van delen en ontmoeten.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Waarom houden verhuurders van dit systeem?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Het is meer dan een economie, het is een nieuwe manier van reizen.`,
  "0__de_frais": `0€ kosten`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Uitwisselingen zijn volledig gratis. Geen servicekosten, geen schoonmaakkosten (tenzij specifiek overeengekomen).`,
  confiance_totale: `Totaal vertrouwen`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Alleen geverifieerde hosts kunnen handelen. U verwelkomt iemand die de waarde van wonen kent.`,
  simplicit_: `Eenvoud`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Vergeet de waarde van punten. Een nacht is een nacht. De uitwisseling is gebaseerd op vertrouwen tussen hosts.`,
  rejoignez_la_communaut__des_h_tes: `Sluit u aan bij de hostcommunity`,
  rejoignez_la_communaut__et_commencez____changer_: `Sluit je aan bij de community en begin met chatten.`,
  commencer_maintenant: `Begin nu`,
  pr_nom_invalide: `Ongeldige voornaam`,
  nom_invalide: `Ongeldige naam`,
  email_invalide: `Ongeldig e-mailadres`,
  s_lectionne_un_pays: `Selecteer een land`,
  s_lectionne_un_mode_tarifaire: `Selecteer een prijsmethode`,
  s_lectionne_ton_usage: `Selecteer uw gebruik`,
  tu_dois_accepter_les_conditions: `U moet de voorwaarden`,
  france: `accepteren Frankrijk`,
  belgique: `België`,
  suisse: `Zwitserland`,
  canada: `Canada`,
  allemagne: `Duitsland`,
  espagne: `Spanje`,
  italie: `Italië`,
  portugal: `Portugal`,
  royaume_uni: `Verenigd Koninkrijk`,
  _tats_unis: `Verenigde Staten`,
  autre: `Andere`,
  merci_de_corriger_les_champs_en_erreur_: `Corrigeer de onjuiste velden.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Er is een fout opgetreden. Probeer het over enkele ogenblikken opnieuw.`,
  compte_cr___avec_succ_s: `Account succesvol aangemaakt`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `U ontvangt een e-mail om uw reizigers-/hostprofiel af te ronden.`,
  cr_er_un_autre_compte: `Maak nog een account aan`,
  activation_traveltrok: `Activering DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Kies uw modus: reiziger, gastheer of gemengd gebruik.`,
  pr_nom: `Voornaam`,
  jeanne: `Jane`,
  nom: `Naam`,
  durand: `Durand`,
  email: `E-mail`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Telefoon (optioneel)`,
  pays: `Land`,
  choisir_un_pays: `Kies een land`,
  mode_tarifaire: `Prijsmethode`,
  voyageur: `Reiziger`,
  nuit: `nacht`,
  h_te: `Gastheer`,
  pro_multi_logements: `Pro multi-behuizing`,
  mois: `maand`,
  usage_principal: `Hoofdgebruik`,
  je_voyage_principalement: `Ik reis voornamelijk`,
  je_loue_principalement: `Ik huur voornamelijk`,
  je_fais_les_deux: `Ik doe beide`,
  nombre_de_logements: `Aantal accommodaties`,
  logement: `accommodatie`,
  logements: `accommodatie`,
  a: `een`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Ik accepteer de gebruiksvoorwaarden en het privacybeleid.`,
  cr_ation_en_cours___: `Creatie wordt uitgevoerd...`,
  cr_er_mon_compte_traveltrok: `Maak mijn TRAVELTROK-account aan`,
  r_servation_de_logements: `Accommodatiereservering`,
  support_h_te_prioritaire: `Prioritaire hostondersteuning`,
  carte___filtres_avanc_s: `Kaart + geavanceerde filters`,
  flux_de_r_servation__tape_par__tape: `Stapsgewijs boekingsproces`,
  couverture_dommages_assistance: `Schade-/bijstandsdekking`,
  multi_logements___reporting: `Multi-housing + rapportage`,
  accueil: `Thuis`,
  tarifs: `Prijzen`,
  "0__commission_pour_les_h_tes": `0% commissie voor hosts`,
  r_volution_traveltrok: `DONKEY TRAVEL Revolutie`,
  gardez_100__de_ce_que_vous_gagnez: `Behoud 100% van wat u verdient`,
  simple: `Simpel`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `U kent uw kosten voordat u boekt. Geen verrassingen bij het betalen.`,
  honn_te: `Eerlijk`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Voor iedereen hetzelfde principe: reiziger en gastheer worden met dezelfde regel behandeld.`,
  utile: `Handig`,
  je_suis_voyageur: `Ik ben een reiziger`,
  je_suis_h_te: `Ik ben een gastheer`,
  j_ai_plusieurs_logements: `Ik heb verschillende accommodaties`,
  simulateur_comparatif_host: `Vergelijkende hostsimulator`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Vergelijk Booking, Airbnb en DONKEY TRAVEL met je eigen cijfers.`,
  nombre_de_nuits: `Aantal nachten`,
  property_price___night__eur_: `Vastgoedprijs / nacht (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Overige kosten (schoonmaak, receptie, linnengoed, etc.) EUR`,
  option___qui_paie_les_frais__5____: `Optie: Wie betaalt de kosten (5%)?`,
  standard__recommand__: `Standaard (aanbevolen)`,
  pro___attractivit_: `Pro / Aantrekkelijkheid`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `De reiziger betaalt 5% meer. U ontvangt 100% van de prijs.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `U betaalt de 5%. De aan de reiziger getoonde prijs is netto.`,
  base_de_calcul: `Berekeningsbasis`,
  nuit_s_: `nacht(en)`,
  autres_frais: `Overige kosten`,
  montant_total_avant_commissions: `Totaalbedrag vóór commissies`,
  plateforme: `Platform`,
  frais_h_te: `Hostkosten`,
  frais_voyageur: `Reiskosten`,
  total_voyageur: `Totaal aantal reizigers`,
  net_h_te: `Nethost`,
  avantage_fiscal___pro: `Belasting- en pro-voordeel`,
  consultez_votre_expert_comptable_: `Raadpleeg uw accountant.`,
  diff_rence_h_te__claire_et_vendeuse: `Hostverschil: duidelijk en verkoopachtig`,
  frais_h_te___an: `Hostkosten / jaar`,
  _conomie_compar_e___booking: `Economie vergeleken met boeken`,
  _conomie_vs_airbnb: `Economie versus Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Typisch voorbeeld over een periode van 1 jaar (host)`,
  nuits_r_serv_es: `Gereserveerde nachten`,
  s_jours___an: `Verblijven / jaar`,
  chiffre_d_affaires_annuel: `Jaaromzet`,
  frais_traveltrok: `TRAVELTROK-kosten`,
  frais_booking__15__: `Boekingskosten (15%)`,
  frais_airbnb__15_5__: `Airbnb-kosten (15,5%)`,
  net_h_te_traveltrok: `Nethost DONKEY TRAVEL`,
  comparatif_des_modes: `Vergelijking van modi`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Wat u activeert op basis van uw TRAVELTROK-gebruik.`,
  fonction: `Functie`,
  pro: `Pro`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Maak uw account en uw gebruiksmodus aan`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Kies of je begint als reiziger, gastheer of beide. U kunt op elk moment wijzigen.`,
  location_simple_c_t__voyageur: `Verhuur van losse personen aan de passagierszijde`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Zoeken, filters, snel boeken en transparante kosten.`,
  gestion_h_te_simplifi_e: `Vereenvoudigd hostbeheer`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Publiceer uw accommodatie, beheer uw agenda en reageer snel op aanvragen.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Dekking inbegrepen voor de reiziger en de gastheer.`,
  support_op_rationnel: `Operationele ondersteuning`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Ondersteuning bij een geschil, annulering of behoefte aan bemiddeling.`,
  faq_tarifs: `Veelgestelde vragen over prijzen`,
  vraiment_0__de_commission_pour_l_h_te__: `Echt 0% commissie voor de host?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Ja. De host ontvangt 100% van de door hem vastgestelde prijs. Geen servicekosten, geen verwerkingskosten.`,
  combien_paie_le_voyageur__: `Hoeveel betaalt de reiziger?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `De reiziger betaalt een commissie van 5% over het huurbedrag. Dit omvat de lopende kosten, verzekering en ondersteuning.`,
  puis_je__changer_mon_logement_gratuitement__: `Kan ik mijn accommodatie gratis ruilen?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Ja ! Bent u verhuurder, dan kunt u kosteloos (€ 0,-) uw accommodatie ruilen met andere leden.`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Waarom is dit model goedkoper?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Door in totaal slechts 5% te nemen (vergeleken met 15% tot 20% elders), maken we reizen toegankelijker en betalen we verhuurders beter.`,
  pr_t___activer_ton_mode_traveltrok__: `Klaar om uw TRAVELTROK-modus te activeren?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Reiziger, host of hybride: begint met duidelijke logica en gecontroleerde kosten.`,
  cr_er_mon_compte: `Maak mijn account aan`,
  explorer_les_logements: `Ontdek accommodatie`,
  donn_es_personnelles: `Persoonlijke gegevens`,
  politique_de_confidentialit_: `Privacybeleid`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Sluit u aan bij onze community en boek accommodatie op {{city}} met duidelijke vaste kosten en verzekering inbegrepen.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Een Europees uitwisselingsplatform gereserveerd voor Airbnb-hosts`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Privéclub voor gasten met een beoordeling van 4,5+: een uniek abonnement om te wisselen in heel Europa.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Gereserveerd voor Airbnb-hosts met een beoordeling groter dan of gelijk aan 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `50% reductie in 2026: 25EUR/jaar in plaats van 50EUR/jaar. Levenslange prijsgarantie voor de eerste 1000 registraties.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Laagseizoen, pauzes, ontmoetingen tussen gasten, vakantiebesparingen: alles is ontworpen voor actieve gasten in Europa.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Reis goedkoper (5% kosten), host gratis (0%). Het eerlijkste model op de markt.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Geen commissies meer van 15% of meer. Met DONKEY TRAVEL betalen verhuurders geen kosten. Reizigers betalen slechts 5% servicekosten. Dat is eerlijkheid.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Vergelijkende hypothese: commissie voor boekingshosts 15% (afhankelijk van land en programma), Airbnb-host-only-modus van 15,5% aan de kant van de verhuurder en 0 aan de kant van de reiziger.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `Als u een bedrijf bent, kunt u de vergoeding van 5% van uw kosten aftrekken. Het 0%-model vereenvoudigt de persoonlijke boekhouding.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Met DONKEY TRAVEL kunt u de prijs van uw huurwoningen verlagen, zodat u vaker kunt huren. Uw hostkosten blijven vast, zodat uw net sterk blijft.`,
  en_moyenne__c_est_environ___annualhostcase_average: `Gemiddeld is dit ongeveer {{savings}}EUR aan jaarlijkse besparingen vergeleken met op commissie gebaseerde platforms.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Aannames: 100EUR per nacht, 30EUR schoonmaak, gemiddelde duur 3 nachten, 50% jaarlijks boekingspercentage.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL verzamelt alleen de gegevens die nodig zijn voor de werking van de dienst: account, profiel, uitwisselingen en ondersteuning.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Uw gegevens worden alleen gedeeld met essentiële technische diensten (authenticatie, hosting, beveiliging) en worden nooit doorverkocht.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `U kunt een verzoek indienen om uw persoonlijke gegevens bij te werken of te verwijderen uit uw account of door contact op te nemen met de ondersteuning.`,
  "help.faq.q1.question": "Hoeveel kost het abonnement?",
  "help.faq.q1.answer":
    "€50/jaar voor het klassieke plan. Er is een introductiekorting van €25/jaar voor 2026.",
  "help.faq.q2.question": "Kan ik ruilen zonder dezelfde datums te hebben?",
  "help.faq.q2.answer":
    "Absoluut. Ons flexibele ruilsysteem stelt host 1 in staat om in juli naar de plaats van host 2 te komen, en host 2 om in september naar de plaats van host 1 te komen, asynchroon.",
  "help.faq.q3.question":
    "Is de site echt gereserveerd voor hosts met een beoordeling van 4,5 en hoger?",
  "help.faq.q3.answer":
    "Ja. Donkey Travel is een besloten club. Bij registratie verifiëren we de link naar uw Airbnb-advertentie om ervoor te zorgen dat uw gemiddelde beoordeling ten minste 4,5/5 is en dat u beoordelingen heeft.",
  "help.faq.q4.question": "Hoe worden de ruilen georganiseerd?",
  "help.faq.q4.answer":
    "Er is geen puntensysteem. Leden bepalen zelf hoeveel nachten ze willen ruilen op basis van de prijs die ze aangeven. De Airbnb-advertentie dient als referentie om te controleren of het voorstel eerlijk en geloofwaardig is.",
  "help.faq.q5.question": "Zijn er extra kosten (schoonmaak, service)?",
  "help.faq.q5.answer":
    "Nee! Het principe van Donkey Travel is 100% gratis ruilen tussen gastheren. De ontvangende gastheer bereidt de accommodatie voor en de gast retourneert deze in onberispelijk schone staat (of regelt de schoonmaak met de gastheer volgens hun afspraken).",
  "help.faq.q6.question": "Kan ik meerdere Airbnb-advertenties koppelen?",
  "help.faq.q6.answer":
    "Ja, dit staat gepland in onze aankomende updates om u in staat te stellen meerdere accommodaties te synchroniseren en nog meer ruilmogelijkheden te krijgen.",
  "help.faq.q7.question": "Wat gebeurt er als een ruil wordt geannuleerd?",
  "help.faq.q7.answer":
    "In het geval van een annulering nodigen we u uit om via onze interne berichtenuitwisseling met uw gastheer te communiceren om een nieuwe overeenkomst of nieuwe data te vinden.",
  "help.faq.q8.question": "Hoe worden vertrouwen en veiligheid gegarandeerd?",
  "help.faq.q8.answer":
    "Door alleen bevestigde gastheren (beoordeling > 4,5) te accepteren, zorgen we ervoor dat alle leden weten wat het betekent om te 'hosten'. Verder worden identiteit en advertenties door ons team geverifieerd.",
};
